export const Theme = {
  Colors: {
    PageBg: "#0B1D27",
    Header: "#FFFFFF",
    SubHeading: "#CEE002",
    White: "#ffffff",
    Para: "rgba(255, 255, 255, 0.6)",
    LightBox: "rgba(206, 224, 2, 0.5)"
  },
  Fonts: {
    Arial: `'Arial', sans-serif`,
    Poppins: `'Poppins', sans-serif`,
    Josefin: `'Josefin Sans', sans-serif;`,
    Montserrat: `'Montserrat', sans-serif`,
  },
  MediaQueries: {
    s: {
      query: "only screen and (min-width:576px)",
    },
    m: {
      query: "only screen and (min-width:768px)",
    },
    l: {
      query: "only screen and (min-width:992px)",
    },
    xl: {
      query: "only screen and (min-width:1200px)",
    },
    xxl: {
      query: "only screen and (min-width:1400px)",
    },
  },
};
